module.exports = __webpack_public_path__ + "static/media/Mylynh.a9d4a501.jpg";